import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { MembershipRole } from '../services/auth.service';

interface RequireMembershipProps {
  roles: MembershipRole[];
  children: React.ReactNode;
}

/** Blocks a route unless the active tenant membership role is in `roles`. */
export const RequireMembership: React.FC<RequireMembershipProps> = ({ roles, children }) => {
  const { membershipRole, isLoading } = useAuth();

  if (isLoading) return null;
  if (!membershipRole || !roles.includes(membershipRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default RequireMembership;
